import { Collapse, CollapseProps, ConfigProvider } from 'antd';
import React from 'react';

const Accordeon = ({
  panels,
  activeKey,
}: {
  panels: any;
  activeKey?: number;
}) => {
  const items: CollapseProps['items'] = panels;

  const isDark =
    typeof window !== 'undefined' &&
    document.documentElement.classList.contains('dark');

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: isDark ? '#1f2937' : '#ffffff',
            colorBgContainer: isDark ? '#111827' : '#ffffff',
            colorBorder: isDark ? '#374151' : '#F1F5F9',
            colorText: isDark ? '#e5e7eb' : '#111827',
          },
        },
      }}
    >
      <Collapse accordion items={items} defaultActiveKey={activeKey ?? 0} />
    </ConfigProvider>
  );
};

export default Accordeon;
